import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import './Video.css'
import { Player, ControlBar, BigPlayButton } from 'video-react';
import "video-react/dist/video-react.css";
import { ThreeDots } from 'react-loading-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVideoSlash } from '@fortawesome/free-solid-svg-icons'
import { API } from '../backend';
import Loading from '../loading/loading';

const Video = () => {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingExam, setLoadingExam] = useState(false);
    const [examQuestions, setExamQuestions] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const [sectionId, setSectionId] = useState(location.state?.sectionId);
    const courseId = location.state?.contenteId;
    const token = Cookies.get('token');
    const [remainingTime, setRemainingTime] = useState(10);
    const [countdownActive, setCountdownActive] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const token = Cookies.get("token"); // Get the token from cookies
                
                const headers = {
                    "Content-Type": "application/json",
                };
                
                if (token) {
                    headers["Authorization"] = `Token ${token}`;
                }
                // Fetch course data
                const courseResponse = await axios.get(`${API}api/v1/course/${courseId}/`,
                    { headers }
                );
                setVideos(courseResponse.data);

                // Fetch exam questions for the section
                if (sectionId) {
                    const examResponse = await axios.get(`${API}api/v1/question/?section_id=${sectionId}`);
                    setExamQuestions(examResponse.data || []); // Store questions in state
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [courseId, sectionId]);

    useEffect(() => {
        if (countdownActive && remainingTime > 0) {
            const interval = setInterval(() => {
                setRemainingTime((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [remainingTime, countdownActive]);

    if (loading) {
        return (
            <>
            <div className="loading-container-course">
                <Loading/>
            </div>
            <div className="loading-container-course-mobile">
                <Loading/>
            </div>
            </>
        )
      }

    const handleStartExam = async () => {
        setLoadingExam(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            navigate("/exam", { state: { sectionId, examData: examQuestions } });
        } catch (error) {
            console.error("Error starting exam:", error);
            alert("خطا در دریافت سوالات، لطفا دوباره تلاش کنید!");
        } finally {
            setLoadingExam(false);
        }
    };

    const handleVideoPlay = async () => {
        if (!token) setCountdownActive(true);

        try {
            await axios.post(
                `${API}api/v1/video_view/`,
                { section: sectionId },
                { headers: { Authorization: `Token ${token}` } }
            );

            setCountdownActive(true);
        } catch (error) {
            console.error("Error recording video view:", error);
        }
    };

    
  return (
    <>
        <div className='video-main'>
            <div className='video-margin-top'></div>
            <div className='video-title-container'>
                <p className='video-title'>
                {videos.title}
                </p>
            </div>
            <div className='video-container'>
                <div className='video-left'>
                    <div className='margin-top-bottom'></div>
                    {videos.sections.map((video, index) => (
                    <div className='video-list' key={index}>
                        <div 
                            className={`video-list-item ${video.id === sectionId ? 'active-border' : ''}`} 
                            onClick={() => {
                                setSectionId(video.id);
                                setRemainingTime(10);
                                setCountdownActive(false);
                            }}
                        >
                            <div className='video-list-left'>
                                <div className='video-image-div'>
                                    <img src={video.image || require("../images/video-image.png")} alt="video-image" className='video-image'/>
                                </div>
                            </div>
                            <div className='video-list-right'>
                                <div className='counter-logo'>
                                    <p className='counter-title'>درس 0{index + 1}/0{videos.sections.length}</p>
                                    <svg className='video-counter-svg' viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.33333 28.3333H15C17.7614 28.3333 20 30.5719 20 33.3333V16.6666C20 11.9526 20 9.59556 18.5355 8.13109C17.0711 6.66663 14.714 6.66663 10 6.66663H8.33333C6.76198 6.66663 5.97631 6.66663 5.48816 7.15478C5 7.64294 5 8.42861 5 9.99996V25C5 26.5713 5 27.357 5.48816 27.8451C5.97631 28.3333 6.76198 28.3333 8.33333 28.3333Z" fill="#E53B1F" />
                                        <path d="M31.6665 28.3333H26.6665C23.9051 28.3333 21.6665 30.5719 21.6665 33.3333V16.6666C21.6665 11.9526 21.6665 9.59556 23.131 8.13109C24.5954 6.66663 26.9525 6.66663 31.6665 6.66663C33.2379 6.66663 34.0235 6.66663 34.5117 7.15478C34.9998 7.64294 34.9998 8.42861 34.9998 9.99996V25C34.9998 26.5713 34.9998 27.357 34.5117 27.8451C34.0235 28.3333 33.2379 28.3333 31.6665 28.3333Z" fill="#3CCFF1" fill-opacity="0.5" />
                                        <path d="M8.3335 6.91663C8.3335 6.77855 8.44542 6.66663 8.5835 6.66663H13.0835C13.2216 6.66663 13.3335 6.77855 13.3335 6.91663V13.994C13.3335 14.3652 12.8847 14.5511 12.6222 14.2887L11.1281 12.7946C10.9654 12.6319 10.7016 12.6319 10.5389 12.7946L9.04479 14.2887C8.78231 14.5511 8.3335 14.3652 8.3335 13.994V6.91663Z" fill="#3CCFF1" fill-opacity="0.5" />
                                    </svg>
                                </div>
                                <p className='video-description'>{video.title}</p>
                                <p className='video-time'>{video.duration}</p>
                                {video.status && (
                                <div className='video-token'>
                                    <p className='token-text'>توکن دریافت شده</p>
                                    <svg className='token-svg' viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM13.7682 6.64018C14.1218 6.21591 14.0645 5.58534 13.6402 5.23178C13.2159 4.87821 12.5853 4.93554 12.2318 5.35982L8.63383 9.67736C8.28711 10.0934 8.09219 10.3238 7.93658 10.4653L7.93063 10.4707L7.92422 10.4659C7.75643 10.339 7.54146 10.1272 7.1585 9.74428L5.70711 8.29289C5.31658 7.90237 4.68342 7.90237 4.29289 8.29289C3.90237 8.68342 3.90237 9.31658 4.29289 9.70711L5.74428 11.1585L5.78511 11.1993L5.78512 11.1993C6.11161 11.526 6.4257 11.8402 6.71794 12.0611C7.0453 12.3087 7.47402 12.5415 8.02343 12.5165C8.57284 12.4916 8.97872 12.221 9.28233 11.9448C9.55337 11.6983 9.83772 11.3569 10.1333 11.0021L10.1333 11.0021L10.1703 10.9577L13.7682 6.64018Z" fill="#22E51F" />
                                    </svg>
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                    ))}
                    <div className='margin-top-bottom1'></div>
                </div>
                <div className='video-right'>
                    <div className='video'>
                    {videos.sections.find(section => section.id === sectionId)?.video_file ? (
                        <Player
                            playsInline
                            poster={videos.sections.find(section => section.id === sectionId)?.image || require("../images/video-image1.png")}
                            src={videos.sections.find(section => section.id === sectionId).video_file}
                            onPlay={handleVideoPlay}
                        >
                        <BigPlayButton position="center"/>
                        <ControlBar autoHide={false} />
                        </Player>
                    ) : (
                        
                        <FontAwesomeIcon icon={faVideoSlash} className='react-font' />
                    )}
                    </div>
                    <div className='video-title1'>
                        <p className='video-counter1'>درس 0{videos.sections.find(section => section.id === sectionId).order}/0{videos.sections.length}</p>
                        <svg className='video-counter-svg' viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.33333 28.3333H15C17.7614 28.3333 20 30.5719 20 33.3333V16.6667C20 11.9526 20 9.5956 18.5355 8.13114C17.0711 6.66667 14.714 6.66667 10 6.66667H8.33333C6.76198 6.66667 5.97631 6.66667 5.48816 7.15483C5 7.64298 5 8.42866 5 10V25C5 26.5714 5 27.357 5.48816 27.8452C5.97631 28.3333 6.76198 28.3333 8.33333 28.3333Z" fill="#E53B1F" />
                            <path d="M31.6665 28.3333H26.6665C23.9051 28.3333 21.6665 30.5719 21.6665 33.3333V16.6667C21.6665 11.9526 21.6665 9.5956 23.131 8.13114C24.5954 6.66667 26.9525 6.66667 31.6665 6.66667C33.2379 6.66667 34.0235 6.66667 34.5117 7.15483C34.9998 7.64298 34.9998 8.42866 34.9998 10V25C34.9998 26.5714 34.9998 27.357 34.5117 27.8452C34.0235 28.3333 33.2379 28.3333 31.6665 28.3333Z" fill="#3CCFF1" fill-opacity="0.5" />
                            <path d="M8.3335 6.91667C8.3335 6.7786 8.44542 6.66667 8.5835 6.66667H13.0835C13.2216 6.66667 13.3335 6.7786 13.3335 6.91667V13.9941C13.3335 14.3653 12.8847 14.5512 12.6222 14.2887L11.1281 12.7946C10.9654 12.6319 10.7016 12.6319 10.5389 12.7946L9.04479 14.2887C8.78231 14.5512 8.3335 14.3653 8.3335 13.9941V6.91667Z" fill="#3CCFF1" fill-opacity="0.5" />
                        </svg>
                    </div>
                    <div className='video-title2-div'>
                        <p className='video-title2'>{videos.sections.find(section => section.id === sectionId).title}</p>
                    </div>
                    <p className='video-text'>{videos.sections.find(section => section.id === sectionId).description}</p>
                    <div className='line-div'>
                        <div className='line'></div>
                    </div>
                    <p className='video-exam-title'>آزمون بده و پاداش بگیر</p>
                    <div className='video-exam-text-div'>
                        <p className='video-exam-text'>مطمئن باش که ابتدا ویدیو را تماشا کردی!</p>
                    </div>
                    <div className='btn-div'>
                        <button 
                                className={`exam-btn ${loadingExam || examQuestions.length === 0 || videos.sections.find(section => section.id === sectionId)?.status || remainingTime > 0 ? 'disabled' : ''}`}
                                onClick={handleStartExam} 
                                disabled={loadingExam || examQuestions.length === 0 || videos.sections.find(section => section.id === sectionId)?.status || (remainingTime > 0 && !videos.sections.find(section => section.id === sectionId)?.video_status)}>
                                {loadingExam ? (
                                <ThreeDots speed={.5} fill="gray" style={{ width: '50px' }}/>
                                ) : videos.sections.find(section => section.id === sectionId)?.status ? (
                                    "قبول شدی"
                                ) : examQuestions.length === 0 ? (
                                    "آزمون ندارد"
                                ) : remainingTime > 0 && !videos.sections.find(section => section.id === sectionId)?.video_status ? (
                                    `${remainingTime} ثانیه`
                                ) : (
                                    "آزمون بده "
                                )}
                        </button>
                    </div>
                </div>
            </div>
            <div className='margin-video-main'></div>
        </div>
        
        <div className='video-main-mobile'>
            <div className='video-margin-top-mobile'></div>
            <div className='video-title-container-mobile'>
                <p className='video-title-mobile'>
                {videos.title}
                </p>
            </div>
            <div className='video-mobile'>
                {videos.sections.find(section => section.id === sectionId)?.video_file ? (
                <Player
                    playsInline
                    poster={videos.sections.find(section => section.id === sectionId)?.image || require("../images/video-image1.png")}
                    src={videos.sections.find(section => section.id === sectionId).video_file}
                    onPlay={handleVideoPlay}
                    >
                    <BigPlayButton position="center"/>
                <ControlBar autoHide={false} />
                </Player>
                ) : (
                        
                <FontAwesomeIcon icon={faVideoSlash} className='react-font' />
                )}
            </div>
            <div className='video-title1-mobile'>
                <p className='video-counter1-mobile'>درس 0{videos.sections.find(section => section.id === sectionId).order}/0{videos.sections.length}</p>
                <svg className='video-counter-svg-mobile' viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.33333 28.3333H15C17.7614 28.3333 20 30.5719 20 33.3333V16.6667C20 11.9526 20 9.5956 18.5355 8.13114C17.0711 6.66667 14.714 6.66667 10 6.66667H8.33333C6.76198 6.66667 5.97631 6.66667 5.48816 7.15483C5 7.64298 5 8.42866 5 10V25C5 26.5714 5 27.357 5.48816 27.8452C5.97631 28.3333 6.76198 28.3333 8.33333 28.3333Z" fill="#E53B1F" />
                    <path d="M31.6665 28.3333H26.6665C23.9051 28.3333 21.6665 30.5719 21.6665 33.3333V16.6667C21.6665 11.9526 21.6665 9.5956 23.131 8.13114C24.5954 6.66667 26.9525 6.66667 31.6665 6.66667C33.2379 6.66667 34.0235 6.66667 34.5117 7.15483C34.9998 7.64298 34.9998 8.42866 34.9998 10V25C34.9998 26.5714 34.9998 27.357 34.5117 27.8452C34.0235 28.3333 33.2379 28.3333 31.6665 28.3333Z" fill="#3CCFF1" fill-opacity="0.5" />
                    <path d="M8.3335 6.91667C8.3335 6.7786 8.44542 6.66667 8.5835 6.66667H13.0835C13.2216 6.66667 13.3335 6.7786 13.3335 6.91667V13.9941C13.3335 14.3653 12.8847 14.5512 12.6222 14.2887L11.1281 12.7946C10.9654 12.6319 10.7016 12.6319 10.5389 12.7946L9.04479 14.2887C8.78231 14.5512 8.3335 14.3653 8.3335 13.9941V6.91667Z" fill="#3CCFF1" fill-opacity="0.5" />
                </svg>
            </div>
            <div className='video-title2-div-mobile'>
                <p className='video-title2-mobile'>{videos.sections.find(section => section.id === sectionId).title}</p>
            </div>
            <p className='video-text-mobile'>{videos.sections.find(section => section.id === sectionId).description}</p>
            <div className='video-left-mobile'>
                    <div className='margin-top-bottom-mobile'></div>
                    {videos.sections.map((video, index) => (
                    <div className='video-list-mobile' key={index}>
                        <div 
                            className={`video-list-item-mobile ${video.id === sectionId ? 'active-border' : ''}`} 
                            onClick={() => {
                                setSectionId(video.id);
                                setRemainingTime(10);
                                setCountdownActive(false);
                            }}
                        >
                            <div className='video-list-left-mobile'>
                                <div className='video-image-mobile-div'>
                                    <img src={video.image || require("../images/video-image.png")} alt="video-image" className='video-image-mobile'/>
                                </div>
                            </div>
                            <div className='video-list-right-mobile'>
                                <div className='counter-logo-mobile'>
                                    <p className='counter-title-mobile'>درس 0{index + 1}/0{videos.sections.length}</p>
                                    <svg className='video-counter-svg-mobile' viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.33333 28.3333H15C17.7614 28.3333 20 30.5719 20 33.3333V16.6666C20 11.9526 20 9.59556 18.5355 8.13109C17.0711 6.66663 14.714 6.66663 10 6.66663H8.33333C6.76198 6.66663 5.97631 6.66663 5.48816 7.15478C5 7.64294 5 8.42861 5 9.99996V25C5 26.5713 5 27.357 5.48816 27.8451C5.97631 28.3333 6.76198 28.3333 8.33333 28.3333Z" fill="#E53B1F" />
                                        <path d="M31.6665 28.3333H26.6665C23.9051 28.3333 21.6665 30.5719 21.6665 33.3333V16.6666C21.6665 11.9526 21.6665 9.59556 23.131 8.13109C24.5954 6.66663 26.9525 6.66663 31.6665 6.66663C33.2379 6.66663 34.0235 6.66663 34.5117 7.15478C34.9998 7.64294 34.9998 8.42861 34.9998 9.99996V25C34.9998 26.5713 34.9998 27.357 34.5117 27.8451C34.0235 28.3333 33.2379 28.3333 31.6665 28.3333Z" fill="#3CCFF1" fill-opacity="0.5" />
                                        <path d="M8.3335 6.91663C8.3335 6.77855 8.44542 6.66663 8.5835 6.66663H13.0835C13.2216 6.66663 13.3335 6.77855 13.3335 6.91663V13.994C13.3335 14.3652 12.8847 14.5511 12.6222 14.2887L11.1281 12.7946C10.9654 12.6319 10.7016 12.6319 10.5389 12.7946L9.04479 14.2887C8.78231 14.5511 8.3335 14.3652 8.3335 13.994V6.91663Z" fill="#3CCFF1" fill-opacity="0.5" />
                                    </svg>
                                </div>
                                <p className='video-description-mobile'>{video.title}</p>
                                <p className='video-time-mobile'>{video.duration}</p>
                                {video.status && (
                                <div className='video-token'>
                                    <p className='token-text-mobile'>توکن دریافت شده</p>
                                    <svg className='token-svg-mobile' viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM13.7682 6.64018C14.1218 6.21591 14.0645 5.58534 13.6402 5.23178C13.2159 4.87821 12.5853 4.93554 12.2318 5.35982L8.63383 9.67736C8.28711 10.0934 8.09219 10.3238 7.93658 10.4653L7.93063 10.4707L7.92422 10.4659C7.75643 10.339 7.54146 10.1272 7.1585 9.74428L5.70711 8.29289C5.31658 7.90237 4.68342 7.90237 4.29289 8.29289C3.90237 8.68342 3.90237 9.31658 4.29289 9.70711L5.74428 11.1585L5.78511 11.1993L5.78512 11.1993C6.11161 11.526 6.4257 11.8402 6.71794 12.0611C7.0453 12.3087 7.47402 12.5415 8.02343 12.5165C8.57284 12.4916 8.97872 12.221 9.28233 11.9448C9.55337 11.6983 9.83772 11.3569 10.1333 11.0021L10.1333 11.0021L10.1703 10.9577L13.7682 6.64018Z" fill="#22E51F" />
                                    </svg>
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                    ))}
                    <div className='margin-top-bottom1-mobile'></div>
                </div>
                <div className='line-div-mobile'>
                    <div className='line-mobile'></div>
                </div>
                <div className='video-exam-text-div-mobile'>
                    <p className='video-exam-title-mobile'>آزمون بده و پاداش بگیر</p>
                    <p className='video-exam-text-mobile'>مطمئن باش که ابتدا ویدیو را تماشا کردی!</p>
                </div>
                <div className='btn-div-mobile'>
                    <button 
                        className={`exam-btn-mobile ${loadingExam || examQuestions.length === 0 || videos.sections.find(section => section.id === sectionId)?.status || remainingTime > 0 ? 'disabled' : ''}`}
                        onClick={handleStartExam} 
                        disabled={loadingExam || examQuestions.length === 0 || videos.sections.find(section => section.id === sectionId)?.status || (remainingTime > 0 && !videos.sections.find(section => section.id === sectionId)?.video_status)}>
                        {loadingExam ? (
                        <ThreeDots speed={.5} fill="gray" style={{ width: '50px' }}/>
                        ) : videos.sections.find(section => section.id === sectionId)?.status ? (
                                    "قبول شدی"
                        ) : examQuestions.length === 0 ? (
                                    "آزمون ندارد"
                        ) : remainingTime > 0 && !videos.sections.find(section => section.id === sectionId)?.video_status ? (
                                    `${remainingTime} ثانیه`
                        ) : (
                                    "آزمون بده "
                        )}
                    </button>
                </div>
            <div className='margin-video-main-mobile'></div>
        </div>
        
    </>
  )
}

export default Video